<template>
  <div class="bs-wrapper" :style="{ height: stageHeight + 'px' }">
    <div class="render-list">
      <van-pull-refresh
        class="pull-refresh"
        :pulling-text="PullPullingText"
        :loosing-text="PullLoosingText"
        :loading-text="PullLoadingText"
        v-model="refreshing"
        @refresh="onRefresh"
      >
        <van-list
          v-if="loading || list.length"
          v-model="loading"
          :finished="finished"
          :loading-text="PushLoadingText"
          :finished-text="PushFinishedText"
          :error-text="PushErrorText"
          @load="onLoad"
        >
          <div
            class="list-box flex-col"
            v-for="(item, index) in list"
            :key="index"
          >
            <!-- expired:0,是否失效 0:未失效 1:失效 -->
            <div class="box-con flex-row" :style="{opacity:item.expired==1?0.45:1}" @click="goDetail(item.id,item.way,item.link)">
              <!-- 左侧-缩略图 -->
              <div class="img-con flex-col">
                <van-image
                  lazy-load
                  :src="item.picture"
                />
              </div>
              <!-- 右侧-正文 -->
              <div class="right-con flex-col">
                <div class="name">
                  <span class="name-text van-ellipsis" v-html="item.name"></span>
                  <div class="tongji">
                    <div class="bd1" v-show="item.expired==0 && index<3"></div>
                    <div class="bd1 shixiao" v-show="item.expired==0 && index>=3"></div>
                    <div class="bd1 shixiao" v-show="item.expired==1">
                      已失效
                    </div>
                  </div>
                </div>
                <span class="detail van-ellipsis" v-html="item.detail"></span>
                <div class="time-row flex-row">
                  <i class="icon1" :class="item.expired==0?'active':''"/>
                  <span class="time">{{item.startTime}}~{{item.endTime}}</span>
                </div>
                <span class="info3">阅读{{item.readTimes>=10000?Number(item.readTimes/10000).toFixed(1)+'万':item.readTimes}}</span>
              </div>
            </div>
          </div>
          <div slot="loading" v-if="refreshing"></div>
        </van-list>
        <div v-show="!(loading || list.length)" class="no-resource">
          <img width="250" height="196" src="../../assets/img/common/noResource.png" alt="">
          暂无数据
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { List, PullRefresh, Toast, Image } from 'vant';
import {
  PullPullingText,
  PullLoadingText,
  PullLoosingText,
  PushFinishedText,
  PushLoadingText,
  PushErrorText,
} from '@/config/tipsCopy';

import { mapState } from 'vuex';

import {getInsideList} from '@/api/activity'

export default {
  name: 'plazaActivity',

  mixins: [],

  components: {
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Toast.name]: Toast,
    [Image.name]: Image,
  },

  props: {
    type:{
      type:Number,
      default:0
    }
  },

  data() {
    return {
      // 下拉刷新文案
      PullPullingText,
      PullLoadingText,
      PullLoosingText,
      // 上拉加载文案
      PushFinishedText,
      PushLoadingText,
      PushErrorText,
      // 列表数据
      list: [],
      pageNum: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      refreshing: false,
    };
  },

  computed: {
    isAndroid() {
      return this.$bsUtils.getClientType() === 'android'
    },
    ...mapState({
      stageHeight: (state) => state.base.stageHeight,
    }),
  },

  watch: {
    type:{
      handler(newVal,oldVal){
        if(newVal!=oldVal){
          this.myType= newVal
          this.onRefresh();
        }
      }
    },
  },

  created() {},

  mounted() {
    this.myType = this.type
    this.onRefresh();
    this.$router.afterEach((to,from)=>{
      if(to.name=='plazaActivityInside' && from.name=='plazaActivityInsideDetail'){
        this.onRefresh();
      }
      if(to.name=='plazaActivityInsideDetail' && from.name=='plazaActivityInside'){
        this.onRefresh();
      }
    })
  },

  destroyed() {},

  methods: {
    async onLoad() {
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      // 异步更新数据
      try {
        if (this.refreshing) {
          this.list = [];
        }

        let res = await getInsideList({
          pageNum:this.pageNum,
          pageSize:10,
          plazaId:this.$store.state.account.plazaId,
          type:this.myType
        })
        if(res && res.items) {
          for (let i = 0; i < res.items.length; i++) {
            let _res =  res.items[i]
            _res.startTime = String(_res.startTime).slice(0, 16)
            _res.endTime = String(_res.endTime).slice(0, 16)
            // expired是否失效 0:未失效 1:失效
            this.list.push(_res);
          }
        }

        // this.list = [{}, {}]

        if (this.refreshing) {
          this.refreshing = false;
        }

        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (!res || this.list.length >= res.totalCount) {
          this.finished = true;
        }

        this.pageNum += 1;
      } catch (error) {
        this.finished = true;
        this.loading = false;
        Toast({
          message: error.message || '获取列表失败',
          duration: 1000,
          position: 'top',
        });
      }
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 当前页面编号
      this.pageNum = 1;

      this.list = [];

      // 重新加载数据
      this.loading = true;
      // 获取数据
      setTimeout(() => {
        this.onLoad();
      }, 100);
    },
    // 跳转到详情页面
    goDetail(id){
      this.$router.push({name:'plazaActivityInsideDetail',params:{id}})
    }
  },
};
</script>

<style lang="less" scoped>
.bs-wrapper{
  background: #F4F4F4;
}
.render-list{
  display: block;
  position: relative;
  height: calc(100% - 44px);
  overflow: auto;
}
.pull-refresh {
  height: 100%;
  overflow: auto;
}
.no-resource {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  color: #999999;
  width: 100%;
  height: 100%;
  padding: 127px 0 0;
}
.list-box {
  margin: 10px 10px 0;
  padding: 14px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.06);
  margin-bottom: 8px;
  justify-content: center;
  align-items: flex-start;
  .box-con {
    width: 100%;
    height: 80px;
    .img-con, /deep/.van-image, /deep/.van-image__img {
      display: block;
      width: 80px;
      height: 80px;
      border-radius: 8px;
    }
    .right-con {
      flex: 1;
      margin: 0 0 0 12px;
      .name {
        display: flex;
        width: 100%;
        justify-content: space-between;
        overflow-wrap: break-word;
        color: #333;
        font-size: 16px;
        white-space: nowrap;
        line-height: 22px;
        font-size: 16px;
        font-weight: 500;
        text-align: left;
        align-self: flex-start;
        .name-text {
          flex: 1;
          max-width: 183px;
        }
      }
      .detail {
        width: 240px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 12px;
        white-space: nowrap;
        line-height: 16px;
        text-align: left;
        align-self: flex-start;
        margin-top: 6px;
      }
      .time-row {
        height: 16px;
        justify-content: flex-start;
        margin: 3px 0 2px;
        align-items: center;
        .icon1 {
          width: 12px;
          height: 12px;
          background: url(../../assets/icons/timeArea-2.png) no-repeat;
          margin: 0 3px 0 0;
        }
        .icon1.active{
          background: url(../../assets/icons/timeArea-1.png) no-repeat;
        }
        .time {
          display: block;
          overflow-wrap: break-word;
          color: rgba(153, 153, 153, 1);
          font-size: 12px;
          white-space: nowrap;
          line-height: 16px;
          text-align: left;
        }
      }
      .info3 {
        height: 16px;
        width: 53px;
        overflow-wrap: break-word;
        color: rgba(153, 153, 153, 1);
        font-size: 12px;
        white-space: nowrap;
        text-align: left;
        line-height: 16px;
      }
    }
    .tongji {
      line-height: 22px;
      .bd1 {
        width: 16px;
        height: 20px;
        background: url(../../assets/icons/hotIcon.png)
          0px 0px no-repeat;
        align-self: flex-end;
      }
      .bd1.shixiao{
        align-self: flex-end;
        width: 42px;
        background:transparent;
        font-size:14px;
        color: rgba(204, 204, 204, 1);
        margin-right:0 !important;
      }
    }
  }
}
</style>
